<template>
    <div class="mine-content" @click="onClickMine">
        <div>我的页面</div> 
        <div>点击编辑</div> 
    </div>
</template>

<script>
import emitter from '@/utils/eventbus';
export default {
    name: "MinePageView",
    props: ['bottomTab'],
    components: {
    },
    data() {
        return {
            mBottomTab: this.bottomTab
        }
    },
    methods: {
        onClickMine() {
            emitter.emit('onComponentChange', { type: 'mine', name: '我的页面', component: this.mBottomTab })
        }
    }
}
</script>
  
<style scoped lang="less">
.mine-content {
    height: 100%;
}
</style>